import React from 'react';
import PropTypes from 'prop-types';

import FormGroup from '../../../../../../../../components/global/FormGroup';
import ContactMethodRow from '../ContactMethodRow';

const propTypes = {
  inputId: PropTypes.string.isRequired,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  removable: PropTypes.bool,
  error: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

/**
 * One editable email address.
 *
 * @param {Object} props The component props.
 * @param {String} props.inputId The input id.
 * @param {String} [props.value] The current address.
 * @param {String} [props.placeholder] The input placeholder.
 * @param {Boolean} [props.disabled] Whether the row is read only.
 * @param {Boolean} [props.removable] Whether the row can be removed.
 * @param {Node} [props.error] The error to show under the input.
 * @param {Function} props.onChange Called with the new address.
 * @param {Function} props.onRemove Called when the row is removed.
 * @returns {Node} The rendered row.
 */
const EmailRow = ({
  inputId,
  value,
  placeholder,
  disabled,
  removable,
  error,
  onChange,
  onRemove,
}) => (
  <ContactMethodRow
    removable={removable}
    disabled={disabled}
    removeLabel="Remove email address"
    error={error}
    onRemove={onRemove}
  >
    <FormGroup
      id={inputId}
      aria-label="Email"
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      error={!!error}
      onChange={event => onChange(event.target.value)}
    />
  </ContactMethodRow>
);

EmailRow.propTypes = propTypes;

export default EmailRow;
